import { Dialog, Transition } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { Fragment } from "react"
import { useAuth } from "../context/authContext"
interface ComponentProps {
    children: any
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    title: string
    panelClass?: string
    preventCloseOnBgClick?: boolean
}
export const DialogWrapper: React.FC<ComponentProps> = ({ children, isOpen, setIsOpen, title, panelClass, preventCloseOnBgClick }) => {
    let auth = useAuth()
    const widthClass = /\b!?max-w-/.test(panelClass ?? '') ? '' : 'max-w-md'
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog static as="div" className={`relative z-50 ${auth?.darkTheme ? 'dark': ''}`} onClose={() => (setIsOpen((val => (preventCloseOnBgClick ? val : !val))))}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25 dark:bg-opacity-[0.6]" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className={`w-full ${widthClass} transform rounded-md bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-slate-800 dark:text-white ${panelClass ?? ''}`}>
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-gray-900 dark:text-white mb-3"
                                >
                                    {title}
                                    <button onClick={() => setIsOpen(false)} type="button" className="float-right bg-blue-100 dark:bg-slate-700 dark:text-white text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 font-medium rounded-full text-sm p-1 text-center inline-flex items-center ">
                                        <XMarkIcon className='float-right h-4 w-4' />
                                    </button>
                                </Dialog.Title>
                                {children}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}